module.exports = __webpack_public_path__ + "static/media/grass2.58ea3fad.png";